export default __webpack_public_path__ + "a7e31c2.png";